<template>
  <v-container class="pt-2">
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col align="center" justify="center">
          <span class="font-weight text-h2 grey--text text-darken-2">
            Order Successful!<br />
            <span class="text-h6">(show order summary here)</span>
          </span>
          <v-img class="" height="100" width="220" src="@/assets/images/sigfloLogoTempDark.png" />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  export default {};
</script>
